import React from "react"
import Link from "components/atoms/Link/Link"
import styled from "styled-components"
import { Box, Row } from "ui/components/atoms/_atoms"

const TslNewsletterNav = () => {
  return (
    <Wrapper $marginBottom="M">
      <Row $alignItems="center">
        <Link
          end
          $type="third"
          to="/panel/tsl-newsletter"
          icon="speedometer"
          $marginRight="XS"
          $activeBackground="primary"
        >
          Pulpit
        </Link>
        <Link
          $type="third"
          to="/panel/tsl-newsletter/sources"
          icon="earth-fill"
          $marginRight="XS"
          $activeBackground="primary"
        >
          Źródła
        </Link>
        <Link
          $type="third"
          to="/panel/tsl-newsletter/articles"
          icon="copy"
          $marginRight="XS"
          $activeBackground="primary"
        >
          Artykuły
        </Link>
        <Link
          $type="third"
          to="/panel/tsl-newsletter/events"
          icon="calendar"
          $marginRight="XS"
          $activeBackground="primary"
        >
          Wydarzenia
        </Link>
        <Link
          $type="third"
          to="/panel/tsl-newsletter/subscribers"
          icon="users"
          $marginRight="XS"
          $activeBackground="primary"
        >
          Subskrybenci
        </Link>
        <Link
          $type="third"
          to="/panel/tsl-newsletter/preview"
          icon="eye"
          $activeBackground="primary"
        >
          Podgląd
        </Link>
      </Row>
    </Wrapper>
  )
}

export default TslNewsletterNav

const Wrapper = styled(Box)`
  border-bottom: 1px solid ${({ theme }) => theme.color.borderLight};
  padding-bottom: ${({ theme }) => theme.space.S};
`
